const ContentType = {
    PDF: 'PDF',
    PPT: 'PPT',
    PPTX: 'PPTX',
    DOC: 'DOC',
    DOCX: 'DOCX',
    VIDEO: 'VIDEO',
    MP4: 'MP4',
    AVI: 'AVI',
    WMV: 'WMV',
    MOV: 'MOV',
    YOUTUBE: 'YOUTUBE',
    VIMEO: 'VIMEO',
    URL: 'URL',
    PNG: 'PNG',
    JPG: 'JPG',
    JPEG: 'JPEG',
    MICROAPP: 'MICROAPP'
};

export default ContentType;
